import React, { Fragment } from 'react';
import styled from "styled-components";
import CheckIcon from '@material-ui/icons/Check';

const Unselected = styled.div`
& {
  align-items:center;
  background:#f5f5f5;
  height:20px;
  justify-content:flex-start;  
  max-height:40px;
  padding:8px;
  text-align:left;
  transition: 0.3s background, 0.3s color, 0.3s border;

  /* Work Sans / 14 Regular */
  font-family: Work Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  display: flex;

  /* Text / Black */
  color: #000000;
}
&:hover {
  background:#e2e2e2;
  cursor:pointer    
}
`;
const Selected = styled(Unselected)`
  & {
    background: #0F9AD6;
    color:#fff;
  }
  &.selected {    
    background: #0F9AD6;
    color:white;            
  }
  &:hover {
    background:#43A8FF;
    cursor:pointer    
  }
`;
const Spacer = styled.div`
  flex-grow:1;
`
class MetricSelection extends React.Component {

  renderElement = (metric) => {
    if (metric.isSelected)
      return this.renderSelected(metric.title, metric.screenElementId);
    return this.renderUnselected(metric.title, metric.screenElementId);
  }

  renderSelected = (title, elementId) => {
    const { toggle } = this.props;
    return (
      <Selected onClick={() => toggle(elementId)}>
        <div>{title}</div>
        <Spacer />
        <CheckIcon />
      </Selected>
    )
  }

  renderUnselected = (title, elementId) => {
    const { toggle } = this.props;
    return (
      <Unselected onClick={() => toggle(elementId)}>
        {title}
      </Unselected>
    )
  }

  render() {
    const { metric } = this.props;
    return (
      <Fragment>
        {this.renderElement(metric)}
      </Fragment>
    );
  }
}

export default MetricSelection;
